import React from "react";

const Product = () => {
    return <>Product</>;
};

export default Product;
